import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台亮点
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            三大核心优势，重新定义在线追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((feature, index) => (
            <div
              key={index}
              className="p-8 bg-background-100 rounded-lg text-center hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
            >
              <span className="w-16 h-16 flex items-center justify-center mx-auto rounded-full bg-primary-100 text-primary-500">
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-900">
                {feature.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}